import React from 'react'
import { withRouter } from 'react-router-dom'
import arrowIcon from './../../../assets/svg/return.svg'
import './BackButton.css'

const BackButton = ({history}) => {
  return (
    <div className="backButton" onClick={() => history.goBack()}>
      <img src={arrowIcon} alt="Back" />
      <p className="back">Back</p>
    </div>
  )
}

export default withRouter(BackButton);